import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { FormattedMessage } from "react-intl";

const CategoryItem = ({ category, isNarrowScreen }) => {
  const { tagId, tagName, imagePath } = category;
  if (!category) {
    return null;
  }
  const CategoryLink = props => <Link to={`/marketplace/category/${tagId}`} {...props} />;
  const className = !isNarrowScreen ? "card-desktop" : "card-mobile";

  return (
    <div className={className}>
      <div className="category-item">
        <CategoryLink className="image-link">
          <img
            src={imagePath || "/assets/images/hra-cta-bg.png"}
            alt=""
            style={{ width: "100%" }}
          />
        </CategoryLink>
        <br />
        <header style={{ textAlign: "center" }}>
          <CategoryLink>
            <FormattedMessage {...{ id: tagName, defaultMessage: tagName }} />
          </CategoryLink>
        </header>
      </div>
    </div>
  );
};

CategoryItem.propTypes = {
  category: PropTypes.object.isRequired,
  isNarrowScreen: PropTypes.bool,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(CategoryItem);



// WEBPACK FOOTER //
// ./components/marketplace/CategoryItem.jsx